<template>
    <div>
      <AdminOptionsListTable :data="optionsTableData" :loading="loading" :options="options" 
      @on-delete-item="deleteSlug(...arguments, 'eb')" 
      @on-select-product="$router.push(`/admin/eb/${arguments[0]}`)" 
      @on-updated-options-list-table="onUpdatedOptionsListTable"></AdminOptionsListTable>
    </div>
</template>

<script>
  import AdminListMixin from "@/mixins/AdminListMixin";
  import AdminAccessMixin from "@/mixins/AdminAccessMixin";
  import AdminOptionsListTable from "@/components/admin/AdminOptionsListTable";
  import ApiServiceAdmin from "@/services/ApiServiceAdmin";
  export default {
    name: "AdminEbOptionsList",
    mixins: [AdminListMixin, AdminAccessMixin],
    components: {
      AdminOptionsListTable
    },
    data() {
      return {
        options: [],
        totalForSlug: {},
        productsForSlug: {},
        optionsTableData: [],
        loading: false
      };
    },
    methods: {
      getTotalForSlug(slug) {
        return ApiServiceAdmin.getEbTotal([slug]).then((response) => {
            return response.data
        });
      },
      getProductsForSlug(slug) {
        return ApiServiceAdmin.getEb([slug]).then((response) => {
            return response.data
        });
      },
      initOptionsListData() {
        this.options.forEach((o) => {
          o.slugs.forEach((s) => {
            console.log('s',s)
            this.getTotalForSlug(s)
            .then((count) => {
              console.log('this.totalForSlug',this.totalForSlug)
              this.totalForSlug[s] = count;
              if ( count > 0 ) {
                this.getProductsForSlug(s);
              }
            })
          });
        });
      },
      async fetchEbOptions() {
        try {
          this.options = await ApiServiceAdmin.getEbOptions().then((response) => {
            return response.data;
          }); 
        } catch (error) {
          console.error(error);
        }
      },
      fetchOptions() {
        this.loading = true;
        this.fetchEbOptions()
        .then(() => {
          // Create new array with objects, containing useful data for the table
          this.optionsTableData = this.options.map((o) => {
            return {
              _id: o._id,
              name: o.name,
              slugData: o.slugs.map((s) => {
                return {
                  name: s,
                  total: 0,
                  products: [],
                };
              }),
            };
          });
          this.optionsTableData.forEach((o) => {
            o.slugData.forEach((s) => {
              this.getTotalForSlug(s.name)
              .then((count) => {
                s.total = count;
                if ( count > 0 ) {
                  this.getProductsForSlug(s.name)
                  .then((products) => {
                    s.products = products;
                  })
                }
              })
            });
          });
        });
      }
    },
    mounted() {
      this.fetchOptions()
    },
  };
</script>

<style lang="scss" scoped></style>
